import { ICart, IEmptyCart } from '@/src/modules/cart/ICart'

interface IUpdateData {
    cartData: ICart | IEmptyCart
    boxUuid: string
    lineItems: any
    existingPlasticDeliveryIndex: number
}

function updateExistingDeliveryData({
    cartData,
    lineItems,
    boxUuid,
    existingPlasticDeliveryIndex,
}: IUpdateData) {
    // store the list of existing non-box plastics AND line items
    // in boxes that aren't the current box we're editing
    const itemsOutsideOfThisBox: any = []

    cartData.cart_contents.deliveries[
        existingPlasticDeliveryIndex
    ].line_items.forEach((item) => {
        if (item?.customization_data?.box_uuid !== boxUuid) {
            itemsOutsideOfThisBox.push(item)
        }
    })

    // update the line item to include the existing plastic line items outside this box
    // AND the updated line items from this box
    cartData.cart_contents.deliveries[existingPlasticDeliveryIndex].line_items =
        [...itemsOutsideOfThisBox, ...lineItems]
}

export default updateExistingDeliveryData
